import { Typography } from "@commonlibs";
import styled, { css } from "styled-components";
import BaseLayout from "ui/common/components/layout/BaseLayout/BaseLayout";
import { IsLoggedInProps } from "./NotFoundPage.types";

export const NotFoundPageRoot = styled(BaseLayout)<IsLoggedInProps>(
    ({ theme, isLoggedIn }) => css`
        width: 100%;
        height: 100%;
        background-color: ${theme.palette[isLoggedIn ? "background" : "primary"]};
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        row-gap: ${theme.spacing["4"]};
        ${theme.breakpoints.up("maxPageWidth")} {
            position: absolute;
            top: 0;
            left: 0;
        }
    `,
);

export const NotFoundText = styled(Typography)<IsLoggedInProps>(
    ({ theme, isLoggedIn }) => css`
        color: ${theme.palette[isLoggedIn ? "text" : "white"]};
        text-align: center;
    `,
);

export const NotFound404Text = styled(NotFoundText)(
    () => css`
        font-size: 11rem;
        line-height: unset;
    `,
);
